import Cookies from "js-cookie"

export function getCookieValue(key: string) {
  return Cookies.get(key)
}

/**
 * @param {Number} duration How long to store the cookie in days
 */
export function createCookie(key: string, value: string, duration = 365) {
  if (!key || !value) return

  Cookies.set(key, value, {
    path: "/",
    expires: duration,
  })
}

export function deleteCookie(key: string) {
  if (!key) return

  Cookies.remove(key)
}
